/**
 * Currency data with country flags for easy readability
 */

export const CURRENCIES = [
  // Europe
  { code: 'EUR', name: 'Euro', flag: '🇪🇺', countries: ['France', 'Germany', 'Italy', 'Spain', 'Netherlands'] },
  { code: 'GBP', name: 'British Pound', flag: '🇬🇧', countries: ['United Kingdom'] },
  { code: 'CHF', name: 'Swiss Franc', flag: '🇨🇭', countries: ['Switzerland'] },
  { code: 'SEK', name: 'Swedish Krona', flag: '🇸🇪', countries: ['Sweden'] },
  { code: 'NOK', name: 'Norwegian Krone', flag: '🇳🇴', countries: ['Norway'] },
  { code: 'DKK', name: 'Danish Krone', flag: '🇩🇰', countries: ['Denmark'] },
  { code: 'CZK', name: 'Czech Koruna', flag: '🇨🇿', countries: ['Czech Republic'] },
  { code: 'HUF', name: 'Hungarian Forint', flag: '🇭🇺', countries: ['Hungary'] },
  { code: 'PLN', name: 'Polish Zloty', flag: '🇵🇱', countries: ['Poland'] },
  { code: 'RON', name: 'Romanian Leu', flag: '🇷🇴', countries: ['Romania'] },

  // Americas
  { code: 'USD', name: 'US Dollar', flag: '🇺🇸', countries: ['United States', 'Puerto Rico'] },
  { code: 'CAD', name: 'Canadian Dollar', flag: '🇨🇦', countries: ['Canada'] },
  { code: 'MXN', name: 'Mexican Peso', flag: '🇲🇽', countries: ['Mexico'] },
  { code: 'BRL', name: 'Brazilian Real', flag: '🇧🇷', countries: ['Brazil'] },
  { code: 'ARS', name: 'Argentine Peso', flag: '🇦🇷', countries: ['Argentina'] },
  { code: 'CLP', name: 'Chilean Peso', flag: '🇨🇱', countries: ['Chile'] },
  { code: 'COP', name: 'Colombian Peso', flag: '🇨🇴', countries: ['Colombia'] },

  // Asia
  { code: 'JPY', name: 'Japanese Yen', flag: '🇯🇵', countries: ['Japan'] },
  { code: 'CNY', name: 'Chinese Yuan', flag: '🇨🇳', countries: ['China'] },
  { code: 'KRW', name: 'South Korean Won', flag: '🇰🇷', countries: ['South Korea'] },
  { code: 'INR', name: 'Indian Rupee', flag: '🇮🇳', countries: ['India'] },
  { code: 'IDR', name: 'Indonesian Rupiah', flag: '🇮🇩', countries: ['Indonesia'] },
  { code: 'THB', name: 'Thai Baht', flag: '🇹🇭', countries: ['Thailand'] },
  { code: 'MYR', name: 'Malaysian Ringgit', flag: '🇲🇾', countries: ['Malaysia'] },
  { code: 'SGD', name: 'Singapore Dollar', flag: '🇸🇬', countries: ['Singapore'] },
  { code: 'HKD', name: 'Hong Kong Dollar', flag: '🇭🇰', countries: ['Hong Kong'] },
  { code: 'TWD', name: 'New Taiwan Dollar', flag: '🇹🇼', countries: ['Taiwan'] },
  { code: 'PHP', name: 'Philippine Peso', flag: '🇵🇭', countries: ['Philippines'] },
  { code: 'VND', name: 'Vietnamese Dong', flag: '🇻🇳', countries: ['Vietnam'] },
  { code: 'AED', name: 'UAE Dirham', flag: '🇦🇪', countries: ['United Arab Emirates'] },
  { code: 'SAR', name: 'Saudi Riyal', flag: '🇸🇦', countries: ['Saudi Arabia'] },
  { code: 'ILS', name: 'Israeli Shekel', flag: '🇮🇱', countries: ['Israel'] },

  // Oceania
  { code: 'AUD', name: 'Australian Dollar', flag: '🇦🇺', countries: ['Australia'] },
  { code: 'NZD', name: 'New Zealand Dollar', flag: '🇳🇿', countries: ['New Zealand'] },

  // Africa
  { code: 'ZAR', name: 'South African Rand', flag: '🇿🇦', countries: ['South Africa'] },
  { code: 'EGP', name: 'Egyptian Pound', flag: '🇪🇬', countries: ['Egypt'] },
];

/**
 * Get currency flag by code
 * @param {string} code - Currency code (e.g., 'EUR', 'USD')
 * @returns {string} Currency flag emoji
 */
export const getCurrencyFlag = (code) => {
  const currency = CURRENCIES.find(c => c.code === code);
  return currency ? currency.flag : '💱';
};

/**
 * Get currency name by code
 * @param {string} code - Currency code (e.g., 'EUR', 'USD')
 * @returns {string} Currency name
 */
export const getCurrencyName = (code) => {
  const currency = CURRENCIES.find(c => c.code === code);
  return currency ? currency.name : code;
};

/**
 * Format currency with flag
 * @param {string} code - Currency code (e.g., 'EUR', 'USD')
 * @returns {string} Formatted string like "🇪🇺 EUR"
 */
export const formatCurrencyWithFlag = (code) => {
  return `${getCurrencyFlag(code)} ${code}`;
};

/**
 * Get array of currency codes only
 * @returns {string[]} Array of currency codes
 */
export const getCurrencyCodes = () => {
  return CURRENCIES.map(c => c.code);
};
